<template>
  <BaseTableItemAction
    v-can:[deletePermission]
    v-on="$listeners"
    v-bind="$attrs"
    icon="mdi-delete"
    actionName="حذف"
    @click="openDeleteDialog()"
  >
    <DeleteNewsDialog
      :showCondition="showDeleteDialog"
      :item="item"
      :goBackWhenItsFinished="goBackWhenItsFinished"
      @closed="closeDeleteDialog"
    />
    <slot></slot>
  </BaseTableItemAction>
</template>

<script>
import { WRITE_NEWS_PERMISSION } from "@/core/statics/Permissions";
import DeleteNewsDialog from "../dialogs/DeleteNewsDialog.vue";

export default {
  props: {
    item: Object,
    goBackWhenItsFinished: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      deletePermission: WRITE_NEWS_PERMISSION,
      showDeleteDialog: false,
    };
  },
  methods: {
    openDeleteDialog() {
      this.showDeleteDialog = true;
    },
    closeDeleteDialog() {
      this.showDeleteDialog = false;
    },
  },
  components: { DeleteNewsDialog },
};
</script>

<style></style>
